document.addEventListener("DOMContentLoaded", function(event) {

    let swiperIndex = document.querySelector(".JS-index-slider");
    const swiper = new Swiper(swiperIndex, {

        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        autoplay: true,
        speed: 3000,
        loop: true,
        effect: "fade",
    });

});